import { Component, OnInit, ViewChild } from '@angular/core';
import { DateTimeAdapter, OWL_DATE_TIME_FORMATS, OWL_DATE_TIME_LOCALE } from 'ng-pick-datetime';
import { MomentDateTimeAdapter } from 'ng-pick-datetime-moment';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { CommonService } from '../../core/service/common-service/common.service';
import { ToastrService } from 'ngx-toastr';
import { MatTableDataSource, MatSort, MatPaginator, MatSelect, MatOption } from '@angular/material';
import { kpiCustData } from './kpiCustData';
import { FilterPipePipe } from '../../pipes/filter-pipe.pipe';
import { FormControl, FormBuilder, FormGroup } from '@angular/forms';
import { WorkshopData } from '../uam/workshopData';

export const MY_CUSTOM_FORMATS = {
  parseInput: 'LL LT',
  fullPickerInput: 'DD-MM-YYYY LT',
  datePickerInput: 'DD-MM-YYYY',
  timePickerInput: 'LT',
  monthYearLabel: 'MMM YYYY',
  dateA11yLabel: 'LL',
  monthYearA11yLabel: 'MMMM YYYY',
};

@Component({
  selector: 'app-prs-reporting',
  templateUrl: './prs-reporting.component.html',
  styleUrls: ['./prs-reporting.component.scss'],
  providers: [
    { provide: DateTimeAdapter, useClass: MomentDateTimeAdapter, deps: [OWL_DATE_TIME_LOCALE] },
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_CUSTOM_FORMATS },
    FilterPipePipe
  ],
})
export class PrsReportingComponent implements OnInit {

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild('allSelected', { static: true }) private allSelected: MatOption;
  @ViewChild('allSelectedVertical', { static: true }) private allSelectedVertical: MatOption;

  displayedColumns: string[] = [
    'customerName',
    'customerNo',
    'accountType',
    'callType',
    'registrationNo',
    'chassisNo',
    'vehicleModel',
    'dealerCode',
    'dealerName',
    'leadGenerationDate',
    'lastContacted',
    'leadStatus'
  ];

  spinner: boolean;
  userId: string;
  userInfo: any;
  today: Date = new Date();
  toDate: Date;
  fromDate: Date;
  isDateRangeInvalid = false;
  uniqueRegionValue: string[] = [];
  uniqueVerticalValue: string[] = [];
  uniqueDealerCode: string[] = [];
  uniqueReportTypeValue: string[] = [];
  selectedRegionValues: string[] = [];
  selectedVerticalValues: string[] = [];
  selectedDealerCodeValues: string[] = [];
  selectedReportTypeValues: string;
  wsCodeFilter:string;
  region: string;
  vartical: string;
  dataGridDataSource: any;
  reportTypeMap = new Map();
  selectRegion: FormGroup;
  selectVertical: FormGroup;
  regionType: string;
  dataGrideFlag: boolean;
  selectedDealer: any;
  uniqueDealerCodeCopy: string[] = [];
  dealerCode: string[] = [];
  roleId: string;
  uniqueRegion: string[] = [];
  acessType: string;
  uniquePRSReportTypeValue: string[] = [];
  maxDate: Date = new Date();
  prsDataGridSize: number = 0;

  constructor(
    private router: Router,
    private datePipe: DatePipe,
    private commonService: CommonService,
    private toastr: ToastrService,
    private filterPipePipe: FilterPipePipe,
    private fb1: FormBuilder,
    private fb2: FormBuilder
    ) { }

  ngOnInit() {
    this.setDefaultDates();
    this.userId = localStorage.getItem('userId');
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
    this.commonService.roleId = localStorage.getItem('roleId');
    this.roleId = localStorage.getItem('roleId');
    if (localStorage.getItem('userId') == null || localStorage.getItem('userId') == undefined) {
      this.router.navigate(['login']);
    }

    if (localStorage.getItem('uniqueRegionValue') != null || localStorage.getItem('uniqueRegionValue') != undefined) {
      this.uniqueRegionValue = JSON.parse(localStorage.getItem("uniqueRegionValue"));
    }

    if (localStorage.getItem('uniqueVerticalValue') != null || localStorage.getItem('uniqueVerticalValue') != undefined) {
      this.uniqueVerticalValue = JSON.parse(localStorage.getItem("uniqueVerticalValue"));
    }

    this.selectRegion = this.fb1.group({
      regionType: ['']
    });

    this.selectVertical = this.fb2.group({
      verticalType: ['']
    });

    this.uniquePRSReportTypeValue = ['Dealer PRS', 'PRS Call Center'];
    if(this.roleId == '1') {
      this.acessType = 'Dealer PRS';
    } else if(this.roleId == '12') {
      this.acessType = 'PRS Call Center';
    } else if(this.roleId == '15') {
      this.acessType = 'PRS Call Center';
    } else if(this.roleId == '4') {
      this.acessType = 'Dealer PRS';
    } else if(this.roleId == '5') {
      this.acessType = 'Dealer PRS';
    } else if(this.roleId == '6') {
      this.acessType = 'Dealer PRS';
    } else if(this.roleId == '7') {
      this.acessType = 'Dealer PRS';
    }

    this.reportTypeFilterValues();
    this.filterValues();
    // if(this.roleId != '15'){
    //   this.getDataGrid(false);
    // }

    // if(!this.uniqueRegionValue.length || !this.uniqueVerticalValue.length) {
    //   this.filterValues();
    // }
  }

  /**
  * Name: filterValues
  * purpose: To get filter values
  */
  reportTypeFilterValues(): void {
    this.uniqueReportTypeValue = [];
    this.selectedReportTypeValues = '';
    this.commonService.reportTypeFilter()
      .subscribe(res => {
        if (res['responseCode'] == 0 && res['responseData'] != undefined) {
          if (res['responseData'].length) {
            if(this.roleId == '12') {
              res['responseData'].forEach(element => {
                this.uniqueReportTypeValue.push(element.callTypeSeqDesc);
                this.reportTypeMap.set(element.callTypeSeqDesc, element.callTypeSeq);
              });
            } else if(this.roleId == '1' || this.roleId == '5' || this.roleId == '4'
            || this.roleId == '6' || this.roleId == '7') {
              this.uniqueReportTypeValue.push('PRS');
              this.reportTypeMap.set('PRS', '3');
              this.selectedReportTypeValues = 'PRS';
            }
            if(this.roleId == '15' && this.acessType == 'PRS Call Center') {
              res['responseData'].forEach(element => {
                this.uniqueReportTypeValue.push(element.callTypeSeqDesc);
                this.reportTypeMap.set(element.callTypeSeqDesc, element.callTypeSeq);
              });
            } else if(this.roleId == '15' && this.acessType == 'Dealer PRS') {
              this.uniqueReportTypeValue.push('PRS');
              this.reportTypeMap.set('PRS', '3');
              this.selectedReportTypeValues = 'PRS';
            }
          }
        } else {
          this.spinner = false;
          this.toastr.error(res['message'], "Error");
        }
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
  }

  /**
  * Name: filterValues
  * purpose: To get filter values
  */
 filterValues(): void {
  this.commonService.prsReportFilter(this.userId, this.roleId)
    .subscribe(res => {
      if (res['responseCode'] == 0 && res['responseData'] != undefined) {
        if (res['responseData'].length) {
          let uniqueRegionValue = res['responseData'].filter(data=> data.flag=='R');
          if(uniqueRegionValue.length) {
            this.uniqueRegionValue = [];
            uniqueRegionValue.forEach(data => {
              this.uniqueRegionValue.push((data.code).toString());
            });
          }
          this.uniqueRegion = this.uniqueRegionValue;

          let uniqueVerticalValue = res['responseData'].filter(data=> data.flag=='V');
          if(uniqueVerticalValue.length) {
            this.uniqueVerticalValue = [];
            uniqueVerticalValue.forEach(data => {
              this.uniqueVerticalValue.push(data.code);
            });
            this.uniqueVerticalValue.forEach((element,index)=>{
              if(element == null){
                this.uniqueVerticalValue.splice(index,1);
              }
            });
          }

          let uniqueDealerCode = res['responseData'].filter(data=> data.flag=='W');
          if(uniqueDealerCode.length) {
            this.uniqueDealerCode = [];
            uniqueDealerCode.forEach(data => {
              this.uniqueDealerCode.push(data.code);
            });
            this.uniqueDealerCodeCopy = this.uniqueDealerCode;
          }
        }
      } else {
        this.spinner = false;
        this.toastr.error(res['message'], "Error");
      }
    }, err => {
      this.spinner = false;
      this.toastr.error("Something went wrong, Please try again.", "Error");
    });
}

  /**
  * Name: getDataGrid
  * purpose: To prepare call list for dataGrid
  */
  getDataGrid(event: any) {
    this.dataGrideFlag = event;
    //this.spinner = true;
    this.dataGridDataSource = '';
    let region = '';
    let vartical = '';
    if(this.selectRegion.value.regionType != "") {
      this.selectRegion.value.regionType.forEach((element,index) => {
        if(element == "0"){
          this.selectRegion.value.regionType.splice(index,1);
        }
      });
      region = this.selectRegion.value.regionType.toString();
    }
    if(this.selectVertical.value.verticalType != "" && !this.selectVertical){
      this.selectVertical.value.verticalType.forEach((element,index)=>{
        if(element == "0"){
          this.selectVertical.value.verticalType.splice(index,1);
        }
      });
      vartical = this.selectVertical.value.verticalType.toString();
    }
    let dealerCode = this.selectedDealerCodeValues.toString();
    let fdate = this.datePipe.transform(this.fromDate, "yyyy-MM-dd");
    let tdate = this.datePipe.transform(this.toDate, "yyyy-MM-dd");
    let reportType = '';
    if(this.selectedReportTypeValues != '' && this.selectedReportTypeValues != undefined){
      reportType = this.reportTypeMap.get(this.selectedReportTypeValues);
    }
    //this.getDataGridExcelReport(region, vartical, dealerCode, fdate, tdate, reportType);
    this.commonService.getPRSDattaGrid(region, vartical, dealerCode, fdate, tdate, reportType, this.userId, this.roleId)
      .subscribe(res => {
        if (res['responseCode'] == 0 && res['responseData'] != undefined) {
          if (res['responseData'].length) {
            this.dataGridDataSource = new MatTableDataSource<kpiCustData>(res['responseData']);
            this.prsDataGridSize = this.dataGridDataSource.length;
            //this.sort.direction = '';
            this.dataGridDataSource.sort = this.sort;
            this.dataGridDataSource.paginator = this.paginator;
          }
          this.spinner = false;
        } else {
          this.spinner = false;
          this.toastr.error(res['message'], "Error");
        }
      }, err => {
        this.spinner = false;
        this.toastr.error("Something went wrong, Please try again.", "Error");
      });
  }

  /**
   * Name: searchfilter
   * purpose: To apply filter on datagrid
   */
  searchfilter(filterValue: string): void {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataGridDataSource.filter = filterValue;
  }

  /**
   * Name: activeButton
   * purpose: To activat Export Excel and Raw Data Report button
   */
  activeButton(): boolean {
    let flag = false;
    if (this.selectedReportTypeValues != null && this.selectedReportTypeValues != undefined && this.selectedReportTypeValues != '') {
      flag = true;
    }
    return flag;
  }

  /**
  * Name: getRowDataExcelReport
  * purpose: To export Row Data report as excel
  */
  getRowDataExcelReport(){
    if (this.isDateRangeInvalid) {
      this.toastr.error("Please select dates within a 30-day range to proceed.", "Error");
      return;
    }
    this.spinner = true;
    let region = '';
    let vartical = '';
    if(this.selectRegion.value.regionType != ""){
      this.selectRegion.value.regionType.forEach((element,index)=>{
        if(element == "0"){
          this.selectRegion.value.regionType.splice(index,1);
        }
      });
      region = this.selectRegion.value.regionType.toString();
    }
    if(this.selectVertical.value.verticalType != "" && !this.selectVertical){
      this.selectVertical.value.verticalType.forEach((element,index)=>{
        if(element == "0"){
          this.selectVertical.value.verticalType.splice(index,1);
        }
      });
      vartical = this.selectVertical.value.verticalType.toString();
    }
    let dealerCode = this.selectedDealerCodeValues.toString();
    let fdate = this.datePipe.transform(this.fromDate, "yyyy-MM-dd");
    let tdate = this.datePipe.transform(this.toDate, "yyyy-MM-dd");
    let reportType = this.reportTypeMap.get(this.selectedReportTypeValues);
    let fileName = "Report on Calling Data From " + fdate + " To " + tdate;
    let roleID = '';
    if(this.roleId == '15' && this.acessType == 'PRS Call Center') {
      roleID = '12';
    } else {
      roleID = this.roleId;
    }
    this.commonService.getRowDataExcelReport(region, vartical, dealerCode, fdate, tdate, reportType, this.userId, roleID)
      .subscribe(fileData => {
        if (fileData) {
          const blob: any = new Blob([fileData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          let link = document.createElement("a");
          if (link.download !== undefined) {
            let url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.spinner = false;
          }
        } else {
          this.spinner = false;
        }
      }, err => {
        this.spinner = false;
      });
  }

  /**
  * Name: getPRSRowDataExcelReport
  * purpose: To export Row Data report as excel
  */
 getPRSRowDataExcelReport(){
  if (this.isDateRangeInvalid) {
    this.toastr.error("Please select dates within a 30-day range to proceed.", "Error");
    return;
  }
  this.spinner = true;
  let region = '';
  let vartical = '';
  if(this.selectRegion.value.regionType != ""){
    this.selectRegion.value.regionType.forEach((element,index)=>{
      if(element == "0"){
        this.selectRegion.value.regionType.splice(index,1);
      }
    });
    region = this.selectRegion.value.regionType.toString();
  }
  if(this.selectVertical.value.verticalType != "" && !this.selectVertical){
    this.selectVertical.value.verticalType.forEach((element,index)=>{
      if(element == "0"){
        this.selectVertical.value.verticalType.splice(index,1);
      }
    });
    vartical = this.selectVertical.value.verticalType.toString();
  }
  let dealerCode = this.selectedDealerCodeValues.toString();
  let fdate = this.datePipe.transform(this.fromDate, "yyyy-MM-dd");
  let tdate = this.datePipe.transform(this.toDate, "yyyy-MM-dd");
  let reportType = this.reportTypeMap.get(this.selectedReportTypeValues);
  let fileName = "Report on Calling Data From " + fdate + " To " + tdate;
  if(tdate <= '2023-01-31') {
  this.commonService.getPRSRowDataExcelReport(region, vartical, dealerCode, fdate, tdate, reportType, this.userId, this.roleId)
    .subscribe(fileData => {
      if (fileData) {
        const blob: any = new Blob([fileData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        let link = document.createElement("a");
        if (link.download !== undefined) {
          let url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.spinner = false;
        }
      } else {
        this.spinner = false;
      }
    }, err => {
      this.spinner = false;
    });
  } else if(fdate > '2023-01-31') {
    this.commonService.getNewPRSRowDataExcelReport(region, vartical, dealerCode, fdate, tdate, reportType, this.userId, this.roleId)
    .subscribe(fileData => {
      if (fileData) {
        const blob: any = new Blob([fileData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        let link = document.createElement("a");
        if (link.download !== undefined) {
          let url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.spinner = false;
        }
      } else {
        this.spinner = false;
      }
    }, err => {
      this.spinner = false;

      });

  }
  else{
    this.toastr.error("Please Select Date before 31-01-2023")
    this.spinner = false;
  }
}

  /**
  * Name: getExportExcelReport
  * purpose: To export report as excel
  */
 getExportExcelReport(): void {
  if (this.isDateRangeInvalid) {
    this.toastr.error("Please select dates within a 30-day range to proceed.", "Error");
    return;
  }
    this.spinner = true;
    let region = '';
    let vartical = '';
    if(this.selectRegion.value.regionType != ""){
      this.selectRegion.value.regionType.forEach((element,index)=>{
        if(element == "0"){
          this.selectRegion.value.regionType.splice(index,1);
        }
      });
      region = this.selectRegion.value.regionType.toString();
    }
    if(this.selectVertical.value.verticalType != "" && !this.selectVertical){
      this.selectVertical.value.verticalType.forEach((element,index)=>{
        if(element == "0"){
          this.selectVertical.value.verticalType.splice(index,1);
        }
      });
      vartical = this.selectVertical.value.verticalType.toString();
    }
    let dealerCode = this.selectedDealerCodeValues.toString();
    let fdate = this.datePipe.transform(this.fromDate, "yyyy-MM-dd");
    let tdate = this.datePipe.transform(this.toDate, "yyyy-MM-dd");
    let reportType = this.reportTypeMap.get(this.selectedReportTypeValues);
    let fileName = "SRM_Data Status Report_From_" + fdate + "_To_" + tdate;
    let roleID = '';
    if(this.roleId == '15' && this.acessType == 'PRS Call Center') {
      roleID = '12';
    } else {
      roleID = this.roleId;
    }
    this.commonService.getExportExcelReport(region, vartical, dealerCode, fdate, tdate, reportType, this.userId, roleID)
      .subscribe(fileData => {
        if (fileData) {
          const blob: any = new Blob([fileData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          let link = document.createElement("a");
          if (link.download !== undefined) {
            let url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.spinner = false;
          }
        } else {
          this.spinner = false;
        }
      }, err => {
        this.spinner = false;
      });
  }

   /**
  * Name: getPRSExportExcelReport
  * purpose: To export prs report as excel
  */
 getPRSExportExcelReport(): void {
  if (this.isDateRangeInvalid) {
    this.toastr.error("Please select dates within a 30-day range to proceed.", "Error");
    return;
  }
  this.spinner = true;
  let region = '';
  let vertical = '';
  let workshop = '';
  if(this.selectRegion.value.regionType != ""){
    this.selectRegion.value.regionType.forEach((element,index)=>{
      if(element == "0"){
        this.selectRegion.value.regionType.splice(index,1);
      }
    });
    region = this.selectRegion.value.regionType.toString();
  }
  if(this.selectVertical.value.verticalType != "" && !this.selectVertical){
    this.selectVertical.value.verticalType.forEach((element,index)=>{
      if(element == "0"){
        this.selectVertical.value.verticalType.splice(index,1);
      }
    });
    vertical = this.selectVertical.value.verticalType.toString();
  }
  let dealerCode = this.selectedDealerCodeValues.toString();
  let startDate = this.datePipe.transform(this.fromDate, "yyyy-MM-dd");
  let endDate = this.datePipe.transform(this.toDate, "yyyy-MM-dd");
  let fileName = "SRM_Data Status Report_From_" + startDate + "_To_" + endDate;
  this.spinner = false;
  if(endDate <= '2023-01-31') {
  this.commonService.getPRSExportExcelReport(region, vertical, dealerCode, startDate, endDate, this.userId, this.roleId)
    .subscribe(fileData => {
      if (fileData) {
        const blob: any = new Blob([fileData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        let link = document.createElement("a");
        if (link.download !== undefined) {
          let url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.spinner = false;
        }
      } else {
        this.spinner = false;
      }
    }, err => {
      this.spinner = false;
    });
  }
  else if(startDate > '2023-01-31'){
    this.commonService.getNewPRSExportExcelReport(region, vertical, dealerCode, startDate, endDate, this.userId, this.roleId)
    .subscribe(fileData => {
      if (fileData) {
        const blob: any = new Blob([fileData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        let link = document.createElement("a");
        if (link.download !== undefined) {
          let url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.spinner = false;
        }
      } else {
        this.spinner = false;
      }
    }, err => {
      this.spinner = false;
    });
  }else{
    this.toastr.error("Please Select Date before 31-01-2023");
    this.spinner = false;
  }

}

  /**
   * Name: filterTriggered
   * @param {Event} event - region filter data
   * purpose: To set dealer code filter values
   */
  filterTriggered(event: any): void {
    this.dataGrideFlag = true;
    this.uniqueDealerCode = [];
    this.selectedDealerCodeValues = [];
    let value;
    if(this.selectRegion.value.regionType == "0") {
      value = '';
    } else {
      value = this.selectRegion.value.regionType.toString();
    }
    this.commonService.getdealerCode(value)
    .subscribe(res => {
      if (res['responseCode'] == 0 && res['responseData'] != undefined) {
        if (res['responseData'].length) {
          res['responseData'].forEach(element => {
            this.uniqueDealerCode.push(element.workshopCode);
          });
          this.uniqueDealerCodeCopy = this.uniqueDealerCode;
          this.spinner = false;
        }
      } else {
        this.spinner = false;
        this.toastr.error(res['message'], "Error");
      }
    }, err => {
      this.spinner = false;
      this.toastr.error("Something went wrong, Please try again.", "Error");
    });
  }

  /**
  * Name: toggleAllSelection
  * purpose: To select/remove all data in workshop drop down
  */
 toggleAllSelectionVertical(): void {
    if (this.allSelectedVertical.selected) {
      this.selectVertical.controls.verticalType.patchValue([...this.uniqueVerticalValue, 0]);
    } else {
      this.selectVertical.controls.verticalType.patchValue([]);
    }
  }

  tosslePerOneVertical() {
    if (this.allSelectedVertical.selected) {
      this.allSelectedVertical.deselect();
      return false;
    }

    if (this.selectVertical.controls.verticalType.value.length == this.uniqueVerticalValue.length) {
      this.allSelectedVertical.select();
    }
  }

  /**
  * Name: toggleAllSelection
  * purpose: To select/remove all data in workshop drop down
  */
 toggleAllSelectionRegion(): void {
    if (this.allSelected.selected) {
      this.selectRegion.controls.regionType.patchValue([...this.uniqueRegionValue,0]);
    } else {
      this.selectRegion.controls.regionType.patchValue([]);
    }
  }

  tosslePerOneRegion() {
    if (this.allSelected.selected) {
      this.allSelected.deselect();
      return false;
    }

    if (this.selectRegion.controls.regionType.value.length == this.uniqueRegionValue.length) {
      this.allSelected.select();
    }
  }

  /**
  * Name: getDataGridExcelReport
  * purpose: To export data grid report as excel
  */
  getDataGridExcelReport(): void {
    if (this.isDateRangeInvalid) {
      this.toastr.error("Please select dates within a 30-day range to proceed.", "Error");
      return;
    }
    this.spinner = true;
    let region = '';
    let vartical = '';
    if(this.selectRegion.value.regionType != ""){
      this.selectRegion.value.regionType.forEach((element,index)=>{
        if(element == "0"){
          this.selectRegion.value.regionType.splice(index,1);
        }
      });
      region = this.selectRegion.value.regionType.toString();
    }
    if(this.selectVertical.value.verticalType != "" && !this.selectVertical){
      this.selectVertical.value.verticalType.forEach((element,index)=>{
        if(element == "0"){
          this.selectVertical.value.verticalType.splice(index,1);
        }
      });
      vartical = this.selectVertical.value.verticalType.toString();
    }
    let dealerCode = this.selectedDealerCodeValues.toString();
    let fdate = this.datePipe.transform(this.fromDate, "yyyy-MM-dd");
    let tdate = this.datePipe.transform(this.toDate, "yyyy-MM-dd");
    let reportType = '';
    if(this.selectedReportTypeValues != '' && this.selectedReportTypeValues != undefined){
      reportType = this.reportTypeMap.get(this.selectedReportTypeValues);
    }
    let fileName = "Data Grid Report_From_" + fdate + "_To_" + tdate;
    //this.spinner = false;
    this.commonService.getDataGridExcelReport(region, vartical, dealerCode, fdate, tdate, reportType, this.userId, this.roleId)
      .subscribe(fileData => {
        if (fileData) {
          const blob: any = new Blob([fileData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          let link = document.createElement("a");
          if (link.download !== undefined) {
            let url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.spinner = false;
          }
        } else {
          this.spinner = false;
        }
      }, err => {
        this.spinner = false;
      });
  }

  /**
   * Name: clearFilter
   * purpose: To clear filter
   */
  clearFilter(): void {
    //this.selectVertical
    this.selectRegion.setValue({regionType:''});
    this.selectVertical.setValue({verticalType:''});
    this.selectedDealerCodeValues = [];
    if(this.roleId != '1') {
      this.selectedReportTypeValues = '';
    }
    this.today = new Date();
    this.toDate = new Date();
    this.fromDate = new Date();
    this.getDataGrid(false);
    this.activeButton();
  }

  /**
   * Name: activeGridButton
   * purpose: To activat Data Grid Report button
   */
  activeGridButton(): boolean {
    //this.dataGrideFlag = false;
    // if (this.selectedReportTypeValues != null && this.selectedReportTypeValues != undefined && this.selectedReportTypeValues != '') {
    //   flag = true;
    // }
    return this.dataGrideFlag;
  }

  // filterTest(event: any){
  //   this.dataGrideFlag = true;
  // }

  onKey() : void {
    this.uniqueDealerCode = this.uniqueDealerCodeCopy;
    this.dealerCode = [];
    this.selectedDealer = this.selectedDealer.trim();
    this.dealerCode = this.uniqueDealerCode.filter(item =>
      item.toLowerCase().includes(this.selectedDealer.toLowerCase())
    );
    if(this.dealerCode.length > 0){
      this.closeInput();
    }
    this.uniqueDealerCode = [];
    this.uniqueDealerCode = this.dealerCode;
  }

  closeInput() : void {
    if(this.dealerCode.length == 0) {
     this.selectedDealer = '';
     this.uniqueDealerCode = this.uniqueDealerCodeCopy;
    }
  }

  /**
  * Name: getRowLeadDataExcelReport
  * purpose: To export Lead Raw Data report as excel
  */
 getRowLeadDataExcelReport(){
  if (this.isDateRangeInvalid) {
    this.toastr.error("Please select dates within a 30-day range to proceed.", "Error");
    return;
  }
    this.spinner = true;
    let region = '';
    let vartical = '';
    if(this.selectRegion.value.regionType != ""){
      this.selectRegion.value.regionType.forEach((element,index)=>{
        if(element == "0"){
          this.selectRegion.value.regionType.splice(index,1);
        }
      });
      region = this.selectRegion.value.regionType.toString();
    }
    if(this.selectVertical.value.verticalType != "" && !this.selectVertical){
      this.selectVertical.value.verticalType.forEach((element,index)=>{
        if(element == "0"){
          this.selectVertical.value.verticalType.splice(index,1);
        }
      });
      vartical = this.selectVertical.value.verticalType.toString();
    }
    let dealerCode = this.selectedDealerCodeValues.toString();
    let fdate = this.datePipe.transform(this.fromDate, "yyyy-MM-dd");
    let tdate = this.datePipe.transform(this.toDate, "yyyy-MM-dd");
    let reportType = this.reportTypeMap.get(this.selectedReportTypeValues);
    let fileName = "Lead level Report at List generation Date From " + fdate + " To " + tdate;
    let roleID = '';
    if(this.roleId == '15' && this.acessType == 'PRS Call Center') {
      roleID = '12';
    } else {
      roleID = this.roleId;
    }
    this.commonService.getRowLeadDataExcelReport(region, vartical, dealerCode, fdate, tdate, reportType, roleID)
      .subscribe(fileData => {
        if (fileData) {
          const blob: any = new Blob([fileData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          let link = document.createElement("a");
          if (link.download !== undefined) {
            let url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.spinner = false;
          }
        } else {
          this.spinner = false;
        }
      }, err => {
        this.spinner = false;
      });
  }


   /**
  * Name: getPRSRowLeadDataExcelReport
  * purpose: To export PRS Lead Raw Data report as excel
  */
  getPRSRowLeadDataExcelReport() {
    if (this.isDateRangeInvalid) {
      this.toastr.error("Please select dates within a 30-day range to proceed.", "Error");
      return;
    }
    this.spinner = true;
    let region = '';
    let vartical = '';
    if(this.selectRegion.value.regionType != ""){
      this.selectRegion.value.regionType.forEach((element,index)=>{
        if(element == "0"){
          this.selectRegion.value.regionType.splice(index,1);
        }
      });
      region = this.selectRegion.value.regionType.toString();
    }
    if(this.selectVertical.value.verticalType != "" && !this.selectVertical){
      this.selectVertical.value.verticalType.forEach((element,index)=>{
        if(element == "0"){
          this.selectVertical.value.verticalType.splice(index,1);
        }
      });
      vartical = this.selectVertical.value.verticalType.toString();
    }
    let dealerCode = this.selectedDealerCodeValues.toString();
    let fdate = this.datePipe.transform(this.fromDate, "yyyy-MM-dd");
    let tdate = this.datePipe.transform(this.toDate, "yyyy-MM-dd");
    let reportType = this.reportTypeMap.get(this.selectedReportTypeValues);
    let fileName = "Lead level Report at List generation Date From " + fdate + " To " + tdate;
    if(tdate <= '2023-01-31') {
    this.commonService.getPRSRowLeadDataExcelReport(region, vartical, dealerCode, fdate, tdate, reportType, this.userId, this.roleId)
      .subscribe(fileData => {
        if (fileData) {
          const blob: any = new Blob([fileData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          let link = document.createElement("a");
          if (link.download !== undefined) {
            let url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.spinner = false;
          }
        } else {
          this.spinner = false;
        }
      }, err => {
        this.spinner = false;
      });
    } else if(fdate > '2023-01-31') {
      this.commonService.getNewPRSRowLeadDataExcelReport(region, vartical, dealerCode, fdate, tdate, reportType, this.userId, this.roleId)
      .subscribe(fileData => {
        if (fileData) {
          const blob: any = new Blob([fileData], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          let link = document.createElement("a");
          if (link.download !== undefined) {
            let url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.spinner = false;
          }
        } else {
          this.spinner = false;
        }
      }, err => {
        this.spinner = false;
      });
    } else {
      this.toastr.error("Please Select Date before 31-01-2023");
      this.spinner = false;
    }
  }

  dateFilterTriggered(event: any): void {
    this.today = new Date();
    if((new Date(new Date(event.source.value).getTime()+(1000*60*60*24*30))).getTime() >= this.today.getTime()){
      this.today = new Date();
      if((new Date(new Date(event.source.value).getTime()+(1000*60*60*24*30))).getTime() >= this.today.getTime()){
        this.toDate = new Date();
      } else {
          this.toDate = new Date(new Date(event.source.value).getTime()+(1000*60*60*24*30));
      }
    } else {
      this.today = new Date(new Date(event.source.value).getTime()+(1000*60*60*24*30));
      this.toDate = new Date(new Date(event.source.value).getTime()+(1000*60*60*24*30));
    }
  }

  /**
  * Name: setPageData
  * purpose: To set pagesize for table
  */
  setPageData(event) {
    let size = event.pageSize.toString();
    localStorage.setItem('prsDataGridPageSize', size);
  }
  setDefaultDates() {
    const current = new Date();
    this.fromDate = new Date(current.getFullYear(), current.getMonth(), 1); // 1st of current month
    this.toDate = this.today; // Today's date
  }

  // Validate the date range to restrict to 30 days
  validateDateRange(type: 'from' | 'to') {
    this.dataGrideFlag = true;
    const thirtyDaysInMs = 30 * 24 * 60 * 60 * 1000;
    this.isDateRangeInvalid = false;
    this.fromDate = new Date(this.fromDate);
    this.toDate = new Date(this.toDate);
    if (type === 'from') {
      const maxToDate = new Date(this.fromDate.getTime() + thirtyDaysInMs);
      if (this.toDate.getTime() > maxToDate.getTime()) {
        this.isDateRangeInvalid = true;
      } else {
        this.isDateRangeInvalid = false;
      }
    } else if (type === 'to') {
      const minFromDate = new Date(this.toDate.getTime() - thirtyDaysInMs);
      if (this.fromDate.getTime() < minFromDate.getTime()) {
        this.isDateRangeInvalid = true;
      } else {
        this.isDateRangeInvalid = false;
      }
    }
  }
}